import API_ENDPOINTS from '../config/api';
import { get, post, put, del } from '../utils/api';

/**
 * Category API Service
 */

// Get all categories with optional filters
export const getAllCategories = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const url = queryString 
    ? `${API_ENDPOINTS.categories}?${queryString}` 
    : API_ENDPOINTS.categories;
  return await get(url);
};

// Get category stats (with course counts)
export const getCategoryStats = async () => {
  return await get(API_ENDPOINTS.categoryStats);
};

// Get category by ID
export const getCategoryById = async (id) => {
  return await get(API_ENDPOINTS.categoryById(id));
};

// Get category by slug
export const getCategoryBySlug = async (slug) => {
  return await get(API_ENDPOINTS.categoryBySlug(slug));
};

// Create category (Admin only)
export const createCategory = async (categoryData) => {
  return await post(API_ENDPOINTS.categories, categoryData);
};

// Update category (Admin only)
export const updateCategory = async (id, categoryData) => {
  return await put(API_ENDPOINTS.categoryById(id), categoryData);
};

// Delete category (Admin only)
export const deleteCategory = async (id) => {
  return await del(API_ENDPOINTS.categoryById(id));
};

const categoryService = {
  getAllCategories,
  getCategoryStats,
  getCategoryById,
  getCategoryBySlug,
  createCategory,
  updateCategory,
  deleteCategory,
};

export default categoryService;
